import React, { useState } from 'react';
import classes from './Deals.qmee.module.scss';
import OffersControls from 'components/molecules/OffersControls/OffersControls';
import OffersListingPage from 'components/pages/Offers/OffersListingPage';
import { useOfferCategoryNavigation } from 'components/pages/Offers/useOfferCategoryNavigation';
import useOffers from 'components/pages/Offers/useOffers';
import { useDebounce } from 'hooks/useDebounce';
import { PROMOTION_TAG } from 'utils/offers';
import { DEALS } from '../pages';
import { ListingProps } from '../Cashbacks/Cashbacks.qmee';

const Deals: React.FC<ListingProps> = ({ selectedCategory: initialSelectedCategory }) => {
  const { listRef, handleCategorySelect, selectedCategory } =
    useOfferCategoryNavigation(initialSelectedCategory);

  const [searchQuery, setSearchQuery] = useState('');
  const debouncedSearchQuery = useDebounce(searchQuery);

  const { items, promoItem, categories } = useOffers({
    apiField: 'deals',
    requiredTags: [],
    paysReward: false,
    selectedCategory,
    basePath: DEALS.path,
    offerType: 'deal',
    promoTags: [PROMOTION_TAG],
    searchQuery: debouncedSearchQuery,
  });

  return (
    <div className={classes.root}>
      <OffersControls
        categories={categories}
        selectedCategory={selectedCategory}
        onCategorySelect={handleCategorySelect}
        searchQuery={searchQuery}
        onSearchChange={setSearchQuery}
        listRef={listRef}
      />
      <OffersListingPage
        items={items}
        promoItem={promoItem}
        categories={categories}
        searchQuery={searchQuery}
        selectedCategory={selectedCategory}
        onCategorySelect={handleCategorySelect}
        offerType="deal"
      />
    </div>
  );
};

export default Deals;
